import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { removeToast } from "../../../store/actions/toastActions"

// Palette par niveau (cohérente avec COLORS : danger/warning/success/accent).
const LEVELS = {
	danger: { bg: "#FEF2F2", border: "#FECACA", color: "#DC2626" },
	warning: { bg: "#FFFBEB", border: "#FDE68A", color: "#D97706" },
	success: { bg: "#F0FDF4", border: "#BBF7D0", color: "#16A34A" },
	info: { bg: "#EFF6FF", border: "#BFDBFE", color: "#2563EB" },
}

const containerStyle = {
	position: "fixed",
	top: 20,
	right: 20,
	zIndex: 9999,
	display: "flex",
	flexDirection: "column",
	gap: 10,
	maxWidth: 380,
	pointerEvents: "none",
}

const ToastContainer = () => {
	const items = useSelector((s) => s.toastReducer.items)
	const dispatch = useDispatch()
	if (!items.length) return null
	return (
		<div style={containerStyle}>
			<style>
				{`@keyframes toastIn {
					from { opacity: 0; transform: translateX(16px); }
					to { opacity: 1; transform: translateX(0); }
				}`}
			</style>
			{items.map((t) => {
				const lv = LEVELS[t.level] || LEVELS.info
				return (
					<div
						key={t.id}
						onClick={() => dispatch(removeToast(t.id))}
						style={{
							pointerEvents: "auto",
							display: "flex",
							alignItems: "center",
							padding: "12px 16px",
							borderRadius: 12,
							backgroundColor: lv.bg,
							border: `1px solid ${lv.border}`,
							borderLeft: `4px solid ${lv.color}`,
							color: lv.color,
							fontSize: 13,
							fontWeight: 500,
							lineHeight: 1.4,
							cursor: "pointer",
							boxShadow: "0 6px 20px rgba(28, 25, 23, 0.12)",
							fontFamily: "'DM Sans', sans-serif",
							animation: "toastIn 0.18s ease-out",
						}}
					>
						{t.message}
					</div>
				)
			})}
		</div>
	)
}

export default ToastContainer
